(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var mql = window.matchMedia('(min-width: 700px)');

    function sync() {
      var items = document.querySelectorAll('details.footer-collapsible');
      for (var i = 0; i < items.length; i++) {
        // Desktop -> open; mobile -> collapsed (saves footer height).
        items[i].open = mql.matches;
      }
    }

    function init() {
      sync();
      if (mql.addEventListener) {
        mql.addEventListener('change', sync);
      } else if (mql.addListener) {
        mql.addListener(sync);
      }

      // Keep columns open on desktop regardless of how a toggle was triggered
      // (keyboard Enter on the summary bypasses pointer-events:none).
      document.querySelectorAll('details.footer-collapsible').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (mql.matches && !item.open) {
            item.open = true;
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
